<template>
    <div class="metadata-container">
      <div id="panel-capas-header" @click="showHideSection('capas')">
          <div id="triangle-capas" class="triangle hide"></div>
          <div class="panel-text-section-dark">Campaña</div>
      </div>
      <div id="panel-capas-body" class="hide">
      <ul>
        <div v-if="campaign_datas_filtered[this.selected_campaign_data] != undefined">
          <li><p><span class="metadata-blue">Denominación:</span> {{campaign_datas_filtered[this.selected_campaign_data].campaign_name}}</p></li>
          <li><p><span class="metadata-blue">Descripción:</span> {{campaign_datas_filtered[this.selected_campaign_data].campaign_description}}</p></li>
          <li><p><span class="metadata-blue">Abstract:</span> {{campaign_datas_filtered[this.selected_campaign_data].campaign_abstract}}</p></li>
          <li><p><span class="metadata-blue">Objetivo:</span> {{campaign_datas_filtered[this.selected_campaign_data].campaign_goal}}</p></li>
          <li><p><span class="metadata-blue">Código:</span> {{campaign_datas_filtered[this.selected_campaign_data].campaign_code}}</p></li>
          <li><p><span class="metadata-blue">Ubicación:</span> {{campaign_datas_filtered[this.selected_campaign_data].campaign_location}}</p></li>
        </div>
      </ul>
      </div>
      <div id="panel-filtered-header" @click="showHideSection('filtered')">
          <div id="triangle-filtered" class="triangle"></div>
          <div class="panel-text-section-dark">Datos de Medición</div>
      </div>
      <div id="panel-filtered-body">
      <ul>
        <div v-if="campaign_datas_filtered[this.selected_campaign_data] != undefined">
          <li><p><span class="metadata-blue">Nombre set de datos:</span> {{campaign_datas_filtered[this.selected_campaign_data].name}}</p></li>
          <li><p><span class="metadata-blue">Fecha de medición:</span> {{campaign_datas_filtered[this.selected_campaign_data].date}}</p></li>
          <li><p><span class="metadata-blue">Descripción:</span> {{campaign_datas_filtered[this.selected_campaign_data].description}}</p></li>
          <li><p><span class="metadata-blue">Comentarios:</span> {{campaign_datas_filtered[this.selected_campaign_data].comments}}</p></li>
        </div>
      </ul>
      </div>
    </div>
</template>

<script>
  // Vuex
  import { mapGetters } from 'vuex'

  export default {
    name: 'panelMetadata',
    data: function () {
        return {
            
        }
    },
    computed: {
        ...mapGetters(
            "map_params",{
                campaign_datas_filtered: 'campaign_datas_filtered'
            }
        ),
        selected_campaign_data: {
            set (campaign_data) { this.$store.dispatch('map_params/change_selected_campaign_data', parseInt(campaign_data)); },
            get () { return this.$store.state.map_params.selected_campaign_data}
        },
    },
    mounted () {
        this.getCampaignDatas()
    },
    methods: {
        getCampaignDatas: function () {
            this.$store.dispatch('map_params/getCampaignDatas')
        },
        showHideSection(section){
            var triangle = document.getElementById("triangle-" + section);
            var body = document.getElementById("panel-" + section + "-body");

              triangle.classList.toggle("hide");
              body.classList.toggle("hide");

        },
    }
  }
</script>

<style scoped>
ul {
  font-size: 0.8rem;
  line-height: 1rem;
  padding-left: 1.5rem;
}
li {
  list-style-type: none;
}
.metadata-container{
  margin: .5rem 1rem 0 1rem;
  overflow: hidden;
}
.metadata-title {
  font-weight: bold;
  color: #447998;
  font-size: 0.8rem;
}
.metadata-blue {
  color: #447998;
}

.panel-text-section-dark{
  color: #447998;
  font-size: 0.9rem;
  font-weight: bold;
}

#panel-capas-header, #panel-filtered-header, #panel-filtro-header {
    display: flex;
    flex-direction: row;
    cursor:pointer;
    padding: 5px 0 5px 0;
}
#panel-capas-body, #panel-filtered-body, #panel-filtro-body {
    padding: 0px 10px 0px 0px;
    overflow: hidden;
    height: 100%;

    -webkit-transition: .1s ease-in-out;
    -moz-transition: .1s ease-in-out;
    -o-transition: .1s ease-in-out;
    transition: .1s ease-in-out;
}
#panel-capas-body.hide, #panel-filtered-body.hide, #panel-filtro-body.hide {
    padding: 0;
    height: 0px;
}
.triangle {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-left: 10px solid #447998;
    border-bottom: 5px solid transparent;
    position: relative;
    top: 7px;
    margin-right: 6px;    

    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
}
#triangle-capas.hide, #triangle-filtered.hide, #triangle-filtro.hide {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
}
</style>



// WEBPACK FOOTER //
// src/components/mapparams/panelMetadata.vue